module.exports = "/packs/images/homepage/activity/football_mobile~f2337c9ae2df8bc6c60f53a14f794236.jpg";